import React from 'react';
import ContentLoader from 'react-content-loader';

type CheckboxGroupPlaceholdersProps = {
  itemCount?: number;
  className?: string;
};

export const CheckboxGroupPlaceholders = (
  props: CheckboxGroupPlaceholdersProps,
) => {
  const { itemCount = 1, className } = props;

  return (
    <ContentLoader
      viewBox={`0 0 260 ${36 * (itemCount - 1) + 20}`}
      backgroundColor="#e7f1fc"
      foregroundColor="#ffffff"
      className={className}
    >
      {Array(itemCount)
        .fill(1)
        .map((_, index) => (
          <React.Fragment key={`placeholders-${index}`}>
            <rect
              x="0"
              y={`${index * 36}`}
              rx="2"
              ry="2"
              width="20"
              height="20"
            />
            <rect
              x="30"
              y={`${index * 36}`}
              rx="2"
              ry="2"
              width={`${index % 2 === 0 ? 200 : 150}`}
              height="20"
            />
          </React.Fragment>
        ))}
    </ContentLoader>
  );
};
